import { Controller } from '@hotwired/stimulus'
import { initViewport } from './map_state/viewport'
import { initLoader } from './map_state/loader'
import { Renderer } from './renderer'
import { initImportExportTool } from './tools/import_export_tool'
import { initFullscreenTool } from './tools/fullscreen_tool'
import { initMoveToCenterTool } from './tools/move_to_center_tool'
import { initZoomTool } from './tools/zoom_tool'
import { initPanTool } from './tools/pan_tool'
import { initCropTool } from './tools/crop_tool'
import { initHistoryTool } from './tools/history_tool'
import { initResetTool } from './tools/reset_tool'
import { initRotateTool } from './tools/rotate_tool'
import { initPathTracerTool } from './tools/path_tracer_tool'
import { initPathcalculatorTool } from './tools/path_calculator_tool'
import { initEdgeDistanceTool } from './tools/edge_distance_tool'
import { initPointDistanceTool } from './tools/point_distance_tool'
import { initAddSensorTool } from './tools/add_sensor_tool'
import { initLinearFlowTool } from './tools/linear_flow_tool'
import { initGroupTool } from './tools/group_tool'
import { initDragTool } from './tools/drag_tool'
import { initSwapTool } from './tools/swap_tool'
import { initSettingsTool } from './tools/settings_tool'
import { initDarkModeTool } from './tools/dark_mode_tools'

// Connects to data-controller="mct"
export default class extends Controller {
  connect () {
    this.loader = initLoader()
    this.viewport = initViewport()

    this.importExportTool = initImportExportTool()
    this.fullscreenTool = initFullscreenTool()
    this.moveToCenterTool = initMoveToCenterTool()
    this.zoomTool = initZoomTool()
    this.panTool = initPanTool()
    this.cropTool = initCropTool()
    this.historyTool = initHistoryTool()
    this.resetTool = initResetTool()
    this.rotateTool = initRotateTool()
    this.pathTracerTool = initPathTracerTool()
    this.pathcalculatorTool = initPathcalculatorTool()
    this.edgeDistanceTool = initEdgeDistanceTool()
    this.pointDistanceTool = initPointDistanceTool()
    this.addSensorTool = initAddSensorTool()
    this.linearFlowTool = initLinearFlowTool()
    this.groupTool = initGroupTool()
    this.dragTool = initDragTool()
    this.swapTool = initSwapTool()
    this.settingsTool = initSettingsTool()
    this.darkModeTool = initDarkModeTool()

    Renderer.render()
  }

  disconnect () {
    this.viewport?.unBindEvents?.()
    this.importExportTool?.unBindEvents?.()
    this.fullscreenTool?.unBindEvents?.()
    this.moveToCenterTool?.unBindEvents?.()
    this.zoomTool?.unBindEvents?.()
    this.panTool?.unBindEvents?.()
    this.cropTool?.unBindEvents?.()
    this.historyTool?.unBindEvents?.()
    this.resetTool?.unBindEvents?.()
    this.rotateTool?.unBindEvents?.()
    this.pathTracerTool?.unBindEvents?.()
    this.pathcalculatorTool?.unBindEvents?.()
    this.edgeDistanceTool?.unBindEvents?.()
    this.pointDistanceTool?.unBindEvents?.()
    this.addSensorTool?.unBindEvents?.()
    this.linearFlowTool?.unBindEvents?.()
    this.groupTool?.unBindEvents?.()
    this.dragTool?.unBindEvents?.()
    this.swapTool?.unBindEvents?.()
    this.settingsTool?.unBindEvents?.()
    this.darkModeTool?.unBindEvents?.()
  }
}
